
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    setTimeout(function(){ 
      Flits('.flits-profile-menu').prepend('<p class="text">'+ Flits.t("Flits.locals.navigation.profile", "My Profile") +'</p>')
      Flits('.flits-modification-menu').prepend('<p class="text">'+ Flits.t("Flits.locals.navigation.modification", "Modification") +'</p>')
      Flits('.flits-wineclub-menu').prepend('<p class="text">' + Flits.t("Flits.locals.navigation.wine_club", "Wine Club") + '</p>')
    }, 500);
    var settings = event.detail.settings;
    console.log(settings.navs);
    settings.navs[0].title = Flits.t("Flits.locals.navigation.info", "Informations");
    var index = settings.navs.indexOf(settings.navs.find(o => o.url == '#changePassword'));
    [settings.navs[3],settings.navs[index]] =[settings.navs[index],settings.navs[3]];
    index = settings.navs.indexOf(settings.navs.find(o => o.url == '#/subscriptions/list'));
    [settings.navs[4],settings.navs[index]] =[settings.navs[index],settings.navs[4]];
    index = settings.navs.indexOf(settings.navs.find(o => o.title == 'altro'));
    var index1 = settings.navs.indexOf(settings.navs.find(o => o.title == 'indirizzo'));
    [settings.navs[index1],settings.navs[index]] =[settings.navs[index],settings.navs[index1]];
    var obj ={
      title: Flits.t("Flits.locals.navigation.sommelier", "Personal Sommelier"),
      url: "#sommelier",
      target: 0,
      menuClass: null,
      badge: null,
      icon: '<svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve" class=""><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/> </g></g> </svg>',
      isShow: 1,
      loader: { loader_class: null },
      body_html: `<div id="flits_customer_note"></div>`,
    };
    
    index = settings.navs.indexOf(settings.navs.find(o => o.title == 'altro'));
    settings.navs.splice(index+1,0,obj);
    console.log(settings.navs);
    
    var listToDelete = ['#address'];
    for (var i = 0; i < settings.navs.length; i++) {
      var obj = settings.navs[i];
      if (listToDelete.indexOf(obj.url) !== -1) {
        settings.navs.splice(i, 1);
        break;
      }
    }
  });
  Flits(document).on('Flits:Navigation:Added',function(event){
    var navs=event.detail.settings.navs;
    var i=event.detail.i;
    var cloneNode=event.detail.menuItemCloneNode;
    if(navs[i].url == '#profile' || navs[i].url=='#order' || navs[i].url =='#changePassword'){
      cloneNode.addClass('flits-profile-submenu');
    }
    else if(navs[i].url == '#/subscriptions/list' || navs[i].url=='https://form.typeform.com/to/lESP4Mf8' || navs[i].url =='https://form.typeform.com/to/lESP4Mf8' || navs[i].url == 'https://form.typeform.com/to/tXJ6nGAW'){
      cloneNode.addClass('flits-modification-submenu');
      if(navs[i].url != '#/subscriptions/list'){
        navs[i].target = 1;
      }
    }
    else if(navs[i].url == "#sommelier" || navs[i].url == "https://sommelierwinebox.com/pages/porta-un-amico"){
      cloneNode.addClass('flits-wineclub-submenu');
    }
    else if(navs[i].url == "/account/logout"){
      cloneNode.addClass('flits-logout-submenu');
    }
    
    if(Flits('.flits-nav-tabs .flits-profile-submenu').length == 3 && Flits(".flits-account-page-nav .flits-nav-tabs .flits-profile-menu").length == 0){
      Flits('.flits-nav-tabs .flits-profile-submenu').wrapAll('<div class="flits-profile-menu menu"></div>');
    }
    else if(Flits('.flits-nav-tabs .flits-modification-submenu').length == 4 && Flits(".flits-account-page-nav .flits-nav-tabs .flits-modification-menu").length == 0){
      Flits('.flits-nav-tabs .flits-modification-submenu').wrapAll('<div class="flits-modification-menu menu"></div>');
    }
    else if(Flits('.flits-nav-tabs .flits-wineclub-submenu').length == 2 && Flits(".flits-account-page-nav .flits-nav-tabs .flits-wineclub-menu").length == 0){
      Flits('.flits-nav-tabs .flits-wineclub-submenu').wrapAll('<div class="flits-wineclub-menu menu"></div>');
    }
    if(Flits('.flits-nav-tabs .flits-logout-submenu').length == 1 && Flits(".flits-account-page-nav .flits-nav-tabs .flits-logout-menu").length == 0){
      Flits('.flits-nav-tabs .flits-logout-submenu').wrapAll('<div class="flits-logout-menu menu"></div>');
    }
  });
  Flits(document).on('Flits:AccountPage:Loaded',function(event){
    console.log(window.flitsObjects.storeData.should_store_credit_work);
    console.log("test");
    let customer_note_url = Flits.base_url+'/'+Flits.customer_id + "/get_customer_shopify_data";
    Flits.ajax({
      method: "get",
      url: customer_note_url,
      data: {
        token: Flits.token,
        customer_hash: Flits.customerHash
      },
    }).done(function(resp){
        window.flits_customer_note = resp.customer.note;
        if(window.flits_customer_note){
        Flits('#flits_tab_sommelier #flits_customer_note').html(window.flits_customer_note);
        }
      else
        {
          Flits('#flits_tab_sommelier #flits_customer_note').html(Flits.t("Flits.locals.navigation.no_customer_note","No Customer Notes"));
        }
  })
  });
}(Flits));
